import TestimonialImg from "assets/Images/testimonial_img1.jpg";
import TestimonialImg2 from "assets/Images/testimonial_img2.jpg";
import TestimonialImg3 from "assets/Images/testimonial_img3.jpg";

export const cardData = [
  {
    id: 1,
    text: "We’ve helped grow profit to over 650,000 Euros through our hands on approach to achieving business success. We help across all areas of the business from developing a strategy right through to execution.",
    imgSrc: TestimonialImg,
    title: "Business Consultancy ",
  },
  {
    id: 2,
    text: "We take a UX focused approach to building websites. This ensures that your website is more than just an information page but is designed to maximise user friendliness and service conversions.",
    imgSrc: TestimonialImg2,
    title: "Website Development",
  },
  {
    id: 3,
    text: "We’re Ireland’s first total AI solution. We aim to streamline daily pharmacy workflows through our unique software that reduces workload and save pharmacies hundreds of hours. We also scale pharmacy services and revenue through the smart use of patient data.",
    imgSrc: TestimonialImg3,
    title: "Taskgo Pharmacy AI Solution",
  },
  {
    id: 4,
    text: "We deliver managed cybersecurity services for healthcare organisations, providing 24/7 monitoring, threat detection, incident response, vulnerability management and compliance support to protect patient data, reduce cyber risk, and strengthen resilience.",
    imgSrc: TestimonialImg3,
    title: "Vigilion Cybersecurity",
  },
];
